import {S3_VERSION} from '@/services/aem/aemClientService';
import marketService from '@/services/marketService';
import {selectLanguageCode} from '@/state/selectors/global';
import {getState} from '@/state/store';
import urlUtils from '@/utils/urlUtils';

export const isAemPath = () => {
    const path = urlUtils.getCurrentPathname();

    if (path.includes(getAemPath())) return true;

    return false;
};

const getS3Version = () => {
    if (
        process.env.REACT_APP_ENV === 'dev' ||
        process.env.REACT_APP_ENV === 'poc' ||
        process.env.REACT_APP_ENV === 'stg' ||
        process.env.REACT_APP_ENV === 'pp'
    ) {
        return '';
    }

    return `/${S3_VERSION}`;
};

export const getFullAemPath = (marketCode, languageCode) => {
    if (marketCode && languageCode) {
        return `${getAemPath()}/${marketCode}${getS3Version()}/${languageCode.toLowerCase()}`;
    }

    const selectedMarketCode = marketService.getMarketCode();
    const selectedLanguageCode = selectLanguageCode(getState());

    return `${getAemPath()}/${selectedMarketCode}${getS3Version()}/${selectedLanguageCode.toLowerCase()}`;
};

const getAemPath = () => {
    return '/content/pwa-app';
};
